import { render, staticRenderFns } from "./DetailConsentSection.vue?vue&type=template&id=63544803&scoped=true&"
import script from "./DetailConsentSection.vue?vue&type=script&lang=ts&"
export * from "./DetailConsentSection.vue?vue&type=script&lang=ts&"
import style0 from "./DetailConsentSection.vue?vue&type=style&index=0&id=63544803&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63544803",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VIcon})
